import { useMemo, useState } from 'react';
import { CARD_CATALOG, cardsByCategory } from '@ccc/cards';
import { CardTile } from '../components/CardTile';
import { Panel } from '../components/Card';

const CATEGORIES = ['pawn', 'knight', 'bishop', 'rook', 'queen', 'king', 'general'] as const;

export function CardsRoute() {
  const grouped = useMemo(() => cardsByCategory(), []);
  const [filter, setFilter] = useState<string | null>(null);

  const visible = filter
    ? CARD_CATALOG.filter((c) => c.category === filter)
    : CARD_CATALOG;

  return (
    <div className="min-h-full w-full max-w-[1280px] mx-auto px-5 md:px-10 py-6 pb-12 flex flex-col gap-4">
      <div>
        <h1 className="font-display text-3xl font-bold">The deck</h1>
        <p className="text-sm text-ink-muted">
          {CARD_CATALOG.filter((c) => c.status === 'live').length} live cards. {CARD_CATALOG.filter((c) => c.status === 'coming_soon').length} coming soon.
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        <FilterChip label="All" active={filter === null} onClick={() => setFilter(null)} />
        {CATEGORIES.map((cat) => (
          <FilterChip
            key={cat}
            label={cat.charAt(0).toUpperCase() + cat.slice(1)}
            count={grouped[cat]?.length}
            active={filter === cat}
            onClick={() => setFilter(cat)}
          />
        ))}
      </div>
      <Panel className="p-5">
        <div className="grid grid-cols-[repeat(auto-fill,minmax(220px,1fr))] gap-4">
          {visible.map((c) => (
            <CardTile
              key={c.id}
              card={c}
              size="sm"
              rarity={
                c.category === 'general'
                  ? 'rare'
                  : c.category === 'king' || c.category === 'queen'
                  ? 'legendary'
                  : 'common'
              }
            />
          ))}
        </div>
      </Panel>
    </div>
  );
}

function FilterChip({ label, count, active, onClick }: { label: string; count?: number | undefined; active: boolean; onClick: () => void }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`h-9 px-4 rounded-md text-sm font-medium border transition focus-ring ${
        active ? 'border-accent bg-accent/5 text-ink' : 'border-ink/10 text-ink-muted hover:text-ink hover:bg-ink/[0.04]'
      }`}
    >
      {label}
      {count !== undefined && (
        <span className="ml-2 text-xs text-ink-muted">{count}</span>
      )}
    </button>
  );
}
